<script setup>
  import { HOME_FOOTER } from '@/constants/home';

  defineProps({
    // on the homepage the footer continues the CTA's cobalt, so a line separates them
    withTopDivider: {
      type: Boolean,
      default: false,
    },
  });

  const year = new Date().getFullYear();
</script>

<template>
  <footer class="bg-cobalt w-full">
    <div class="mx-auto w-full max-w-299 px-5 md:px-8 xl:px-0">
      <div
        :class="[
          'flex flex-col-reverse items-center gap-5 py-8 text-[14px]/5 text-white/70 lg:flex-row lg:justify-between lg:py-6',
          withTopDivider && 'border-t border-white/20',
        ]"
      >
        <p class="text-center">© {{ year }} {{ HOME_FOOTER.copyright }}</p>

        <nav :aria-label="HOME_FOOTER.label">
          <ul class="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 lg:gap-x-0">
            <li
              v-for="link in HOME_FOOTER.links"
              :key="link.to"
              class="lg:before:mx-3 lg:before:content-['·'] lg:first:before:content-none"
            >
              <router-link
                :to="link.to"
                class="font-medium transition-colors hover:text-white focus-visible:text-white"
              >
                {{ link.title }}
              </router-link>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </footer>
</template>
